import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import "./bookinghome.css";
import Aos from "aos";
import "aos/dist/aos.css";

const BookingHome = () => {
const location = useLocation();
const { tourId, tourTitle, tourImage } = location.state || {};

const [tourDetails, setTourDetails] = useState({
title: tourTitle || "Tour Name",
image: tourImage || "/default-tour.jpg",
});

useEffect(() => {
Aos.init({ duration: 2000 });


// لو الـ state فارغ أو الصورة غير موجودة، نجيب البيانات من API
if ((!tourTitle || !tourImage) && tourId) {
  fetch(`https://orangered-hornet-549881.hostingersite.com/api/tours/${tourId}`)
    .then((res) => res.json())
    .then((data) => {
      const firstImage = data.data.images?.length
        ? `https://orangered-hornet-549881.hostingersite.com/storage/${data.data.images[0]}`
        : "/default-tour.jpg";
      setTourDetails({
        title: data.data.title || "Tour Name",
        image: firstImage,
      });
    })
    .catch((err) => console.error("Error fetching tour:", err));
}


}, [tourId, tourTitle, tourImage]);

return ( <section className="home">
{/* الخلفية */}
{tourDetails.image && ( <img
       src={tourDetails.image}
       alt={tourDetails.title}
       className="backgroundImg"
     />
)}


  {/* Overlay */}
  <div className="overlay"></div>

  {/* المحتوى */}
  <div className="homeContent">
    <h1 className="mainTitle" data-aos="fade-down">
      {tourDetails.title}
    </h1>
  </div>
</section>


);
};

export default BookingHome;
